import { RxFilePlus } from '@react-icons/all-files/rx/RxFilePlus'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import mixpanelClient from '@disco/api/mixpanel'

import {
  AccessibleIcon,
  DropdownMenu,
  Flex as DsFlex,
  IconButton,
  Tooltip,
} from 'components/ds'
import { EllipsisVerticalIcon } from 'components/ui/icon/svg-icons'

import BriefProjectMenuBody from './brief-project-menu-body'
import { useBriefProjectMenu } from './use-brief-project-menu'

interface BriefProjectActionsProps {
  briefProjectId?: string
}

const BriefProjectActions: React.FC<BriefProjectActionsProps> = ({
  briefProjectId,
}) => {
  const navigate = useNavigate()
  const {
    handleRenameProject,
    handleOpenSettings,
    handleDeleteProject,
    dialogs,
  } = useBriefProjectMenu({ briefProjectId })

  const handleCreateNewBrief = () => {
    if (briefProjectId) {
      mixpanelClient.sendPureEvent('Brief created', {
        Context: 'Briefs',
        source: 'project',
        project_id: briefProjectId,
      })
      navigate(`/brief-editor/new?projectId=${briefProjectId}`)
    }
  }

  if (!briefProjectId) {
    return null
  }

  return (
    <>
      <DsFlex align="center" justify="end" gap="2" pr="2">
        <Tooltip content="New brief">
          <IconButton
            variant="ghost"
            color="gray"
            size="2"
            onClick={handleCreateNewBrief}
          >
            <AccessibleIcon label="New Brief">
              <RxFilePlus size={24} />
            </AccessibleIcon>
          </IconButton>
        </Tooltip>
        <DropdownMenu.Root>
          <DropdownMenu.Trigger>
            <IconButton variant="ghost" color="gray" size="2">
              <AccessibleIcon label="Brief Project Actions">
                <EllipsisVerticalIcon size={24} />
              </AccessibleIcon>
            </IconButton>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content variant="soft" align="end">
            <BriefProjectMenuBody
              handleRenameProject={handleRenameProject}
              handleOpenSettings={handleOpenSettings}
              handleDeleteProject={handleDeleteProject}
            />
          </DropdownMenu.Content>
        </DropdownMenu.Root>
      </DsFlex>
      {dialogs}
    </>
  )
}

export default BriefProjectActions
